import { render, staticRenderFns } from "./MyTravel.vue?vue&type=template&id=feb6e424&"
import script from "./MyTravel.vue?vue&type=script&lang=js&"
export * from "./MyTravel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports